import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import TeammateBox from "../../components/Boxs/TeammateBox";
import Page from "../../components/Page";
import Sidebar from "../../components/Sidebar";
import SidebarDrawer from "../../components/SidebarDrawer";
import { url } from "../../url";
import { teammatesAtom } from "../Teammate/atoms/TeammateAtomGlobal";
import { userTeammatesAtom } from "../Teammate/atoms/UserTeammatesAtomGlobal";
import styles from "./teammate.module.scss";
const FoundSkillers = () => {
  const [teammates, setTeammates] = useAtom(teammatesAtom);
  const [userTeammates, setUserTeammates] = useAtom(userTeammatesAtom);
  // const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  // Infinite scroll
  const [hasMore, setHasMore] = useState(true);
  const [index, setIndex] = useState(2);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      const teammates = await axios.get(url + "/teammate", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setTeammates(teammates.data.teammates);

      const token = localStorage.getItem("token");
      if (token) {
        const userTeammates = await axios.get(
          url + `/user/teammates/found?page=${currentPage}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUserTeammates(userTeammates.data.teammates);
        const morePages = userTeammates.data.teammatesPages == 1 ? false : true;
        if (!morePages) {
          setHasMore(false);
        }
      }
    };
    fetchData();
  }, [currentPage, setTeammates, setUserTeammates]);

  const handlePageChange = (value: number) => {
    setCurrentPage(value);
  };

  const fetchMoreSkillers = async () => {
    await axios
      .get(url + `/user/teammates/found?page=${currentPage}`)
      .then((res) => {
        const teammatesArr = res.data.teammates;
        setTeammates((prevTeammates: any[]) => [
          ...prevTeammates,
          ...teammatesArr,
        ]);

        teammatesArr.length > 0 ? setHasMore(true) : setHasMore(false);
      })
      .catch((err) => console.error(err));

    setIndex((prevIndex) => prevIndex + 1);
  };

  const tokenAvailable = () => {
    const token = localStorage.getItem("token");
    if (token) {
      return true;
    }
    return false;
  };

  const deleteFoundedTeammate = async (teammate: any) => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.delete(url + `/user/teammates/${teammate._id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        setUserTeammates(
          userTeammates.filter(function (t: any) {
            return t !== teammate._id;
          })
        );
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <Page>
      <div className={styles.foundSkillers}>
        <header className="foundSkillers__header">
          <div className="foundSkillers__header__sidebar">
            <SidebarDrawer />
          </div>
        </header>
        <div className="foundSkillers__container">
          <div className="foundSkillers__container__sidebar">
            <Sidebar />
          </div>
          <div className="foundSkillers__container__skills">
            {userTeammates.length === 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center' }}>
                <h2 style={{ marginBottom: '2rem', fontSize: '1.8rem', color: '#374151', fontWeight: '400' }}>No teammates added...</h2>
                <Button
                  onClick={() => navigate("/find")}
                  variant="contained"
                  size="large"
                  style={{
                    width: '280px',
                    height: '80px',
                    fontSize: '1.2rem',
                    fontWeight: '500',
                    borderRadius: '6px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                    transition: 'all 0.3s ease',
                    textTransform: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 35px rgba(102, 126, 234, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                  }}
                >
                  Find Teammates
                </Button>
              </div>
            ) : (
              <div className={styles.gridContainer}>
                <InfiniteScroll
                  dataLength={teammates.length}
                  next={fetchMoreSkillers}
                  hasMore={hasMore}
                  loader={<CircularProgress/>}
                  style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))', gap: '2rem' }}
                >
                {teammates.map((teammate: any) => {
                  if (userTeammates.includes(teammate._id)) {
                    return (
                      <div key={teammate._id} className={styles.teammateCard}>
                        <TeammateBox
                          teammate={teammate}
                          tokenAvailable={tokenAvailable()}
                          deleteTeammate={() => deleteFoundedTeammate(teammate)}
                          teammateAdded={true}
                        />
                      </div>
                    );
                  }
                  return null;
                })}
                </InfiniteScroll>
              </div>
            )}
          </div>
        </div>
        {/* <Pagination
          count={pages}
          color="primary"
          onChange={(event, page) => handlePageChange(page)}
          showFirstButton
          showLastButton
          style={{width:"fit-content", margin:"0 auto"}}
        /> */}
      </div>
    </Page>
  );
};

export default FoundSkillers;
